{
  "en": {
    "Создать коллаж · {0} C": "Create collage · {0} C",
    "от {0} до {1} фото": "{0} to {1} photos",
    "Коллаж из фото": "Photo collage",
    "Перемешать": "Shuffle",
    "Загрузите свои фото: раскладка соберётся на них": "Upload your photos: the layout will be built on them",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "Add {0} more photos: the «{1}» layout needs at least {2}",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "The layout takes the first {0} photos, the rest stay for other layouts",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "Hold a photo and drag it onto another to swap them",
    "Перетащите фото на другое, чтобы поменять их местами": "Drag a photo onto another to swap them",
    "Раскладка": "Layout",
    "Все раскладки": "All layouts",
    "Размытие": "Blur",
    "Из фото": "From photo",
    "Отступы": "Spacing",
    "Например: лето у моря": "For example: summer by the sea",
    "Наберём нашим шрифтом": "We set it in our font",
    "Добавьте хотя бы {0} фото": "Add at least {0} photos",
    "Для этой раскладки нужно {0} фото": "This layout needs {0} photos",
    "{0} длиннее {1} знаков": "{0} is longer than {1} characters",
    "Раскладки": "Layouts",
    "Искать среди {0} раскладок": "Search {0} layouts",
    "Коллаж «{0}»": "Collage «{0}»",
    "Подтвердите права на фото": "Confirm the rights to the photos",
    "Создать коллаж": "Create collage",
    "Этот вариант пока недоступен": "This option is not available yet",
    "Загружаем фото": "Uploading photos",
    "за коллаж": "per collage",
    "Пример {0}": "Example {0}",
    "Загрузите от {0} до {1} фото": "Upload {0} to {1} photos",
    "Порядок поменяете прямо в раскладке": "You can change the order right in the layout",
    "Бот уже прислал его в чат, в отдельную тему.": "The bot has already sent it to the chat, in a separate topic.",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "The bot has already sent {0} slides to the chat, in a separate topic. Publish them as a carousel in order.",
    "{0} слайда, {1}": "{0} slides, {1}",
    "фон {0}": "{0} background",
    "без отступов": "no spacing",
    "{0} отступы": "{0} spacing",
    "Фото загружены": "Photos uploaded",
    "Проверяем фото": "Checking the photo",
    "Фото проверены": "Photos checked",
    "Находим лица и главное": "Finding faces and the main subject",
    "Кадры выровнены": "Frames aligned",
    "Выравниваем цвет": "Evening out the colour",
    "Цвет выровнен": "Colour evened out",
    "Собираем коллаж": "Assembling the collage",
    "Коллаж собран": "Collage assembled",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "You can leave the screen: the bot will send the collage to the chat.",
    "Коллаж готов": "The collage is ready",
    "коллаж не создан": "the collage was not created",
    "Не получилось собрать коллаж": "Could not assemble the collage",
    "коллаж": "collage",
    "Подпись не прошла проверку": "The caption did not pass the check",
    "Изменить подпись": "Change the caption",
    "Фото не прошли проверку": "The photos did not pass the check",
    "На фото то, что мы не публикуем.": "The photos show something we do not publish.",
    "Заменить фото": "Replace the photo",
    "Ещё раскладка": "Another layout",
    "Рилс из этих фото": "Reels from these photos",
    "Права на свои фото": "Rights to your photos",
    "Подтверждаю право использовать загружаемые фото": "I confirm the right to use the uploaded photos",
    "на коллаже": "on the collage",
    "Тут откроется тема чата, куда бот прислал коллаж": "The chat topic where the bot sent the collage will open here",
    "Коллаж ещё загружается": "The collage is still loading",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "Could not pass the collage on. Open the work in «History» and try again.",
    "Сетки": "Grids",
    "Свободно": "Free",
    "Ретро": "Retro",
    "С текстом": "With text",
    "Для соцсетей": "For social media",
    "Мозаика": "Mosaic",
    "Кладка из ячеек разной высоты": "A masonry of cells of different heights",
    "Сетка 2×2": "Grid 2×2",
    "Четыре равные ячейки": "Four equal cells",
    "Полароиды": "Polaroids",
    "Карточки в белых рамках, с наклоном": "Cards in white frames, tilted",
    "Плёнка": "Film",
    "Кадры на плёнке и поле для подписи": "Frames on a film strip and a field for a caption",
    "Герой и два": "Hero and two",
    "Крупное фото и два рядом": "A large photo and two next to it",
    "Сетка 3×3": "Grid 3×3",
    "Подборки и итоги года": "Selections and year in review",
    "Герой и лента": "Hero and strip",
    "Крупное фото и лента мелких": "A large photo and a strip of small ones",
    "Журнал": "Magazine",
    "Заголовок, крупное фото и сноски": "A headline, a large photo and footnotes",
    "Ленты во всю ширину, лучше в 9:16": "Full-width strips, best in 9:16",
    "Круги": "Circles",
    "Фото в круглых окнах": "Photos in round windows",
    "Сетка 2×3": "Grid 2×3",
    "Шесть равных ячеек": "Six equal cells",
    "До и после": "Before and after",
    "Два фото с подписями": "Two photos with labels",
    "Мудборд": "Moodboard",
    "Скотч, наклон и заголовок": "Tape, tilt and a headline",
    "Панорама": "Panorama",
    "Один кадр на несколько слайдов карусели": "One shot across several carousel slides",
    "Печать": "Print",
    "Широкий": "Wide",
    "Без отступов": "No spacing",
    "Тонкие": "Thin",
    "Средние": "Medium",
    "Широкие": "Wide",
    "Белый": "White",
    "Чёрный": "Black",
    "Бумага": "Paper",
    "Цвет из фото": "Colour from photo",
    "Размытие из фото": "Blur from photo",
    "Лето 2026": "Summer 2026",
    "Наши выходные": "Our weekend",
    "С днём рождения": "Happy birthday",
    "Дата": "Date",
    "Январь": "January",
    "Февраль": "February",
    "Март": "March",
    "Апрель": "April",
    "Май": "May",
    "Июнь": "June",
    "Июль": "July",
    "Август": "August",
    "Сентябрь": "September",
    "Октябрь": "October",
    "Ноябрь": "November",
    "Декабрь": "December",
    "января": "January",
    "февраля": "February",
    "марта": "March",
    "апреля": "April",
    "мая": "May",
    "июня": "June",
    "июля": "July",
    "августа": "August",
    "сентября": "September",
    "октября": "October",
    "ноября": "November",
    "декабря": "December"
  },
  "hy": {
    "Создать коллаж · {0} C": "Ստեղծել կոլաժ · {0} C",
    "от {0} до {1} фото": "{0}-ից {1} լուսանկար",
    "Коллаж из фото": "Լուսանկարների կոլաժ",
    "Перемешать": "Խառնել",
    "Загрузите свои фото: раскладка соберётся на них": "Վերբեռնեք ձեր լուսանկարները՝ դասավորությունը կկազմվի դրանցով",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "Ավելացրեք ևս {0} լուսանկար՝ «{1}» դասավորությանն անհրաժեշտ է առնվազն {2}",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "Դասավորության մեջ կմտնեն առաջին {0} լուսանկարները, մնացածը կմնան մյուսների համար",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "Պահեք լուսանկարը և տարեք մյուսի վրա՝ տեղերը փոխելու համար",
    "Перетащите фото на другое, чтобы поменять их местами": "Քաշեք լուսանկարը մյուսի վրա՝ տեղերը փոխելու համար",
    "Раскладка": "Դասավորություն",
    "Все раскладки": "Բոլոր դասավորությունները",
    "Размытие": "Մշուշ",
    "Из фото": "Լուսանկարից",
    "Отступы": "Միջակայքեր",
    "Например: лето у моря": "Օրինակ՝ ամառ ծովի մոտ",
    "Наберём нашим шрифтом": "Կհավաքենք մեր տառատեսակով",
    "Добавьте хотя бы {0} фото": "Ավելացրեք առնվազն {0} լուսանկար",
    "Для этой раскладки нужно {0} фото": "Այս դասավորությանն անհրաժեշտ է {0} լուսանկար",
    "{0} длиннее {1} знаков": "{0}-ն ավելի երկար է, քան {1} նիշ",
    "Раскладки": "Դասավորություններ",
    "Искать среди {0} раскладок": "Որոնել {0} դասավորության մեջ",
    "Коллаж «{0}»": "«{0}» կոլաժ",
    "Подтвердите права на фото": "Հաստատեք լուսանկարների իրավունքը",
    "Создать коллаж": "Ստեղծել կոլաժ",
    "Этот вариант пока недоступен": "Այս տարբերակը դեռ հասանելի չէ",
    "Загружаем фото": "Վերբեռնում ենք լուսանկարները",
    "за коллаж": "մեկ կոլաժի համար",
    "Пример {0}": "Օրինակ {0}",
    "Загрузите от {0} до {1} фото": "Վերբեռնեք {0}-ից {1} լուսանկար",
    "Порядок поменяете прямо в раскладке": "Հերթականությունը կփոխեք հենց դասավորության մեջ",
    "Бот уже прислал его в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է այն չատ՝ առանձին թեմայում։",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "Բոտն արդեն ուղարկել է {0} սլայդ չատ՝ առանձին թեմայում։ Հրապարակեք դրանք կարուսելով՝ հերթականությամբ։",
    "{0} слайда, {1}": "{0} սլայդ, {1}",
    "фон {0}": "ֆոն՝ {0}",
    "без отступов": "առանց միջակայքերի",
    "{0} отступы": "{0} միջակայքեր",
    "Фото загружены": "Լուսանկարները վերբեռնված են",
    "Проверяем фото": "Ստուգում ենք լուսանկարը",
    "Фото проверены": "Լուսանկարները ստուգված են",
    "Находим лица и главное": "Գտնում ենք դեմքերն ու գլխավորը",
    "Кадры выровнены": "Կադրերը հավասարեցված են",
    "Выравниваем цвет": "Հավասարեցնում ենք գույնը",
    "Цвет выровнен": "Գույնը հավասարեցված է",
    "Собираем коллаж": "Հավաքում ենք կոլաժը",
    "Коллаж собран": "Կոլաժը հավաքված է",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "Կարող եք դուրս գալ էկրանից՝ բոտը կոլաժը կուղարկի չատ։",
    "Коллаж готов": "Կոլաժը պատրաստ է",
    "коллаж не создан": "կոլաժը չի ստեղծվել",
    "Не получилось собрать коллаж": "Չհաջողվեց հավաքել կոլաժը",
    "коллаж": "կոլաժ",
    "Подпись не прошла проверку": "Ենթագիրը չի անցել ստուգումը",
    "Изменить подпись": "Փոխել ենթագիրը",
    "Фото не прошли проверку": "Լուսանկարները չանցան ստուգումը",
    "На фото то, что мы не публикуем.": "Լուսանկարներում կա այն, ինչ մենք չենք հրապարակում։",
    "Заменить фото": "Փոխել լուսանկարը",
    "Ещё раскладка": "Եվս մեկ դասավորություն",
    "Рилс из этих фото": "Ռիլս այս լուսանկարներից",
    "Права на свои фото": "Ձեր լուսանկարների իրավունքները",
    "Подтверждаю право использовать загружаемые фото": "Հաստատում եմ վերբեռնվող լուսանկարներն օգտագործելու իրավունքը",
    "на коллаже": "կոլաժի վրա",
    "Тут откроется тема чата, куда бот прислал коллаж": "Այստեղ կբացվի չատի թեման, ուր բոտն ուղարկել է կոլաժը",
    "Коллаж ещё загружается": "Կոլաժը դեռ բեռնվում է",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "Չհաջողվեց փոխանցել կոլաժը։ Բացեք աշխատանքը «Պատմություն»-ում և փորձեք կրկին։",
    "Сетки": "Ցանցեր",
    "Свободно": "Ազատ",
    "Ретро": "Ռետրո",
    "С текстом": "Տեքստով",
    "Для соцсетей": "Սոցցանցերի համար",
    "Мозаика": "Խճանկար",
    "Кладка из ячеек разной высоты": "Տարբեր բարձրության բջիջների շարվածք",
    "Сетка 2×2": "Ցանց 2×2",
    "Четыре равные ячейки": "Չորս հավասար բջիջ",
    "Полароиды": "Պոլարոիդներ",
    "Карточки в белых рамках, с наклоном": "Քարտեր սպիտակ շրջանակներում, թեքությամբ",
    "Плёнка": "Ժապավեն",
    "Кадры на плёнке и поле для подписи": "Կադրեր ժապավենի վրա և դաշտ ենթագրի համար",
    "Герой и два": "Գլխավորը և երկուսը",
    "Крупное фото и два рядом": "Մեծ լուսանկար և երկուսը կողքին",
    "Сетка 3×3": "Ցանց 3×3",
    "Подборки и итоги года": "Ընտրանիներ և տարվա ամփոփում",
    "Герой и лента": "Գլխավորը և շերտը",
    "Крупное фото и лента мелких": "Մեծ լուսանկար և փոքրերի շերտ",
    "Журнал": "Ամսագիր",
    "Заголовок, крупное фото и сноски": "Վերնագիր, մեծ լուսանկար և ծանոթագրություններ",
    "Ленты во всю ширину, лучше в 9:16": "Ամբողջ լայնությամբ շերտեր, ավելի լավ է 9:16-ով",
    "Круги": "Շրջանակներ",
    "Фото в круглых окнах": "Լուսանկարներ կլոր պատուհաններում",
    "Сетка 2×3": "Ցանց 2×3",
    "Шесть равных ячеек": "Վեց հավասար բջիջ",
    "До и после": "Առաջ և հետո",
    "Два фото с подписями": "Երկու լուսանկար ենթագրերով",
    "Мудборд": "Մուդբորդ",
    "Скотч, наклон и заголовок": "Կպչուն ժապավեն, թեքություն և վերնագիր",
    "Панорама": "Համայնապատկեր",
    "Один кадр на несколько слайдов карусели": "Մեկ կադր կարուսելի մի քանի սլայդի վրա",
    "Печать": "Տպում",
    "Широкий": "Լայն",
    "Без отступов": "Առանց միջակայքերի",
    "Тонкие": "Բարակ",
    "Средние": "Միջին",
    "Широкие": "Լայն",
    "Белый": "Սպիտակ",
    "Чёрный": "Սև",
    "Бумага": "Թուղթ",
    "Цвет из фото": "Գույն լուսանկարից",
    "Размытие из фото": "Մշուշ լուսանկարից",
    "Лето 2026": "Ամառ 2026",
    "Наши выходные": "Մեր հանգստյան օրերը",
    "С днём рождения": "Ծնունդդ շնորհավոր",
    "Дата": "Ամսաթիվ",
    "Январь": "Հունվար",
    "Февраль": "Փետրվար",
    "Март": "Մարտ",
    "Апрель": "Ապրիլ",
    "Май": "Մայիս",
    "Июнь": "Հունիս",
    "Июль": "Հուլիս",
    "Август": "Օգոստոս",
    "Сентябрь": "Սեպտեմբեր",
    "Октябрь": "Հոկտեմբեր",
    "Ноябрь": "Նոյեմբեր",
    "Декабрь": "Դեկտեմբեր",
    "января": "հունվարի",
    "февраля": "փետրվարի",
    "марта": "մարտի",
    "апреля": "ապրիլի",
    "мая": "մայիսի",
    "июня": "հունիսի",
    "июля": "հուլիսի",
    "августа": "օգոստոսի",
    "сентября": "սեպտեմբերի",
    "октября": "հոկտեմբերի",
    "ноября": "նոյեմբերի",
    "декабря": "դեկտեմբերի"
  },
  "es": {
    "Создать коллаж · {0} C": "Crear collage · {0} C",
    "от {0} до {1} фото": "de {0} a {1} fotos",
    "Коллаж из фото": "Collage de fotos",
    "Перемешать": "Mezclar",
    "Загрузите свои фото: раскладка соберётся на них": "Sube tus fotos: el diseño se armará con ellas",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "Añade {0} fotos más: el diseño «{1}» necesita al menos {2}",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "El diseño usará las primeras {0} fotos; el resto queda para otros",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "Mantén una foto y arrástrala sobre otra para intercambiarlas",
    "Перетащите фото на другое, чтобы поменять их местами": "Arrastra una foto sobre otra para intercambiarlas",
    "Раскладка": "Diseño",
    "Все раскладки": "Todos los diseños",
    "Размытие": "Desenfoque",
    "Из фото": "Desde foto",
    "Отступы": "Márgenes",
    "Например: лето у моря": "Por ejemplo: verano junto al mar",
    "Наберём нашим шрифтом": "Lo escribimos con nuestra fuente",
    "Добавьте хотя бы {0} фото": "Añade al menos {0} fotos",
    "Для этой раскладки нужно {0} фото": "Este diseño necesita {0} fotos",
    "{0} длиннее {1} знаков": "{0} supera los {1} caracteres",
    "Раскладки": "Diseños",
    "Искать среди {0} раскладок": "Buscar entre {0} diseños",
    "Коллаж «{0}»": "Collage «{0}»",
    "Подтвердите права на фото": "Confirma los derechos sobre las fotos",
    "Создать коллаж": "Crear collage",
    "Этот вариант пока недоступен": "Esta opción aún no está disponible",
    "Загружаем фото": "Subiendo fotos",
    "за коллаж": "por collage",
    "Пример {0}": "Ejemplo {0}",
    "Загрузите от {0} до {1} фото": "Sube de {0} a {1} fotos",
    "Порядок поменяете прямо в раскладке": "Cambiarás el orden directamente en el diseño",
    "Бот уже прислал его в чат, в отдельную тему.": "El bot ya lo envió al chat, en un tema aparte.",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "El bot ya envió {0} diapositivas al chat, en un tema aparte. Publícalas como carrusel en orden.",
    "{0} слайда, {1}": "{0} diapositivas, {1}",
    "фон {0}": "fondo {0}",
    "без отступов": "sin márgenes",
    "{0} отступы": "márgenes: {0}",
    "Фото загружены": "Fotos subidas",
    "Проверяем фото": "Comprobando la foto",
    "Фото проверены": "Fotos revisadas",
    "Находим лица и главное": "Buscando rostros y lo principal",
    "Кадры выровнены": "Encuadres ajustados",
    "Выравниваем цвет": "Igualando el color",
    "Цвет выровнен": "Color igualado",
    "Собираем коллаж": "Armando el collage",
    "Коллаж собран": "Collage armado",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "Puedes salir de la pantalla: el bot enviará el collage al chat.",
    "Коллаж готов": "El collage está listo",
    "коллаж не создан": "el collage no se creó",
    "Не получилось собрать коллаж": "No se pudo armar el collage",
    "коллаж": "collage",
    "Подпись не прошла проверку": "El texto no pasó la revisión",
    "Изменить подпись": "Cambiar el texto",
    "Фото не прошли проверку": "Las fotos no superaron la revisión",
    "На фото то, что мы не публикуем.": "Las fotos muestran algo que no publicamos.",
    "Заменить фото": "Cambiar la foto",
    "Ещё раскладка": "Otro diseño",
    "Рилс из этих фото": "Reels con estas fotos",
    "Права на свои фото": "Derechos sobre tus fotos",
    "Подтверждаю право использовать загружаемые фото": "Confirmo el derecho a usar las fotos que subo",
    "на коллаже": "en el collage",
    "Тут откроется тема чата, куда бот прислал коллаж": "Aquí se abrirá el tema del chat donde el bot envió el collage",
    "Коллаж ещё загружается": "El collage aún se está cargando",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "No se pudo pasar el collage. Abre el trabajo en «Historial» y vuelve a intentarlo.",
    "Сетки": "Cuadrículas",
    "Свободно": "Libre",
    "Ретро": "Retro",
    "С текстом": "Con texto",
    "Для соцсетей": "Para redes sociales",
    "Мозаика": "Mosaico",
    "Кладка из ячеек разной высоты": "Mampostería de celdas de distinta altura",
    "Сетка 2×2": "Cuadrícula 2×2",
    "Четыре равные ячейки": "Cuatro celdas iguales",
    "Полароиды": "Polaroids",
    "Карточки в белых рамках, с наклоном": "Tarjetas con marco blanco, inclinadas",
    "Плёнка": "Película",
    "Кадры на плёнке и поле для подписи": "Fotogramas en película y un campo para el texto",
    "Герой и два": "Protagonista y dos",
    "Крупное фото и два рядом": "Una foto grande y dos al lado",
    "Сетка 3×3": "Cuadrícula 3×3",
    "Подборки и итоги года": "Selecciones y resúmenes del año",
    "Герой и лента": "Protagonista y tira",
    "Крупное фото и лента мелких": "Una foto grande y una tira de pequeñas",
    "Журнал": "Revista",
    "Заголовок, крупное фото и сноски": "Titular, foto grande y notas",
    "Ленты во всю ширину, лучше в 9:16": "Tiras a todo el ancho, mejor en 9:16",
    "Круги": "Círculos",
    "Фото в круглых окнах": "Fotos en ventanas redondas",
    "Сетка 2×3": "Cuadrícula 2×3",
    "Шесть равных ячеек": "Seis celdas iguales",
    "До и после": "Antes y después",
    "Два фото с подписями": "Dos fotos con etiquetas",
    "Мудборд": "Moodboard",
    "Скотч, наклон и заголовок": "Cinta, inclinación y titular",
    "Панорама": "Panorama",
    "Один кадр на несколько слайдов карусели": "Una imagen en varias diapositivas del carrusel",
    "Печать": "Impresión",
    "Широкий": "Ancho",
    "Без отступов": "Sin márgenes",
    "Тонкие": "Finos",
    "Средние": "Medianos",
    "Широкие": "Anchos",
    "Белый": "Blanco",
    "Чёрный": "Negro",
    "Бумага": "Papel",
    "Цвет из фото": "Color de la foto",
    "Размытие из фото": "Desenfoque de la foto",
    "Лето 2026": "Verano 2026",
    "Наши выходные": "Nuestro fin de semana",
    "С днём рождения": "Feliz cumpleaños",
    "Дата": "Fecha",
    "Январь": "Enero",
    "Февраль": "Febrero",
    "Март": "Marzo",
    "Апрель": "Abril",
    "Май": "Mayo",
    "Июнь": "Junio",
    "Июль": "Julio",
    "Август": "Agosto",
    "Сентябрь": "Septiembre",
    "Октябрь": "Octubre",
    "Ноябрь": "Noviembre",
    "Декабрь": "Diciembre",
    "января": "de enero de",
    "февраля": "de febrero de",
    "марта": "de marzo de",
    "апреля": "de abril de",
    "мая": "de mayo de",
    "июня": "de junio de",
    "июля": "de julio de",
    "августа": "de agosto de",
    "сентября": "de septiembre de",
    "октября": "de octubre de",
    "ноября": "de noviembre de",
    "декабря": "de diciembre de"
  },
  "de": {
    "Создать коллаж · {0} C": "Collage erstellen · {0} C",
    "от {0} до {1} фото": "{0} bis {1} Fotos",
    "Коллаж из фото": "Fotocollage",
    "Перемешать": "Mischen",
    "Загрузите свои фото: раскладка соберётся на них": "Laden Sie Ihre Fotos hoch: Das Layout wird daraus gebaut",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "Fügen Sie noch {0} Fotos hinzu: Das Layout «{1}» braucht mindestens {2}",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "Das Layout nimmt die ersten {0} Fotos, die übrigen bleiben für andere",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "Halten Sie ein Foto und ziehen Sie es auf ein anderes, um sie zu tauschen",
    "Перетащите фото на другое, чтобы поменять их местами": "Ziehen Sie ein Foto auf ein anderes, um sie zu tauschen",
    "Раскладка": "Layout",
    "Все раскладки": "Alle Layouts",
    "Размытие": "Unschärfe",
    "Из фото": "Aus Foto",
    "Отступы": "Abstände",
    "Например: лето у моря": "Zum Beispiel: Sommer am Meer",
    "Наберём нашим шрифтом": "Wir setzen ihn in unserer Schrift",
    "Добавьте хотя бы {0} фото": "Fügen Sie mindestens {0} Fotos hinzu",
    "Для этой раскладки нужно {0} фото": "Dieses Layout braucht {0} Fotos",
    "{0} длиннее {1} знаков": "{0} ist länger als {1} Zeichen",
    "Раскладки": "Layouts",
    "Искать среди {0} раскладок": "In {0} Layouts suchen",
    "Коллаж «{0}»": "Collage «{0}»",
    "Подтвердите права на фото": "Bestätigen Sie die Rechte an den Fotos",
    "Создать коллаж": "Collage erstellen",
    "Этот вариант пока недоступен": "Diese Variante ist noch nicht verfügbar",
    "Загружаем фото": "Fotos werden hochgeladen",
    "за коллаж": "pro Collage",
    "Пример {0}": "Beispiel {0}",
    "Загрузите от {0} до {1} фото": "Laden Sie {0} bis {1} Fotos hoch",
    "Порядок поменяете прямо в раскладке": "Die Reihenfolge ändern Sie direkt im Layout",
    "Бот уже прислал его в чат, в отдельную тему.": "Der Bot hat es bereits in einem eigenen Thema in den Chat geschickt.",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "Der Bot hat bereits {0} Folien in einem eigenen Thema in den Chat geschickt. Veröffentlichen Sie sie der Reihe nach als Karussell.",
    "{0} слайда, {1}": "{0} Folien, {1}",
    "фон {0}": "Hintergrund {0}",
    "без отступов": "ohne Abstände",
    "{0} отступы": "Abstände: {0}",
    "Фото загружены": "Fotos hochgeladen",
    "Проверяем фото": "Foto wird geprüft",
    "Фото проверены": "Fotos geprüft",
    "Находим лица и главное": "Gesichter und das Wichtigste finden",
    "Кадры выровнены": "Ausschnitte ausgerichtet",
    "Выравниваем цвет": "Farbe wird angeglichen",
    "Цвет выровнен": "Farbe angeglichen",
    "Собираем коллаж": "Collage wird zusammengestellt",
    "Коллаж собран": "Collage zusammengestellt",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "Sie können den Bildschirm verlassen: Der Bot schickt die Collage in den Chat.",
    "Коллаж готов": "Die Collage ist fertig",
    "коллаж не создан": "die Collage wurde nicht erstellt",
    "Не получилось собрать коллаж": "Die Collage konnte nicht erstellt werden",
    "коллаж": "Collage",
    "Подпись не прошла проверку": "Die Bildunterschrift hat die Prüfung nicht bestanden",
    "Изменить подпись": "Bildunterschrift ändern",
    "Фото не прошли проверку": "Die Fotos haben die Prüfung nicht bestanden",
    "На фото то, что мы не публикуем.": "Auf den Fotos ist etwas, das wir nicht veröffentlichen.",
    "Заменить фото": "Foto ersetzen",
    "Ещё раскладка": "Anderes Layout",
    "Рилс из этих фото": "Reels aus diesen Fotos",
    "Права на свои фото": "Rechte an eigenen Fotos",
    "Подтверждаю право использовать загружаемые фото": "Ich bestätige das Recht, die hochgeladenen Fotos zu nutzen",
    "на коллаже": "auf der Collage",
    "Тут откроется тема чата, куда бот прислал коллаж": "Hier öffnet sich das Chat-Thema, in das der Bot die Collage geschickt hat",
    "Коллаж ещё загружается": "Die Collage wird noch geladen",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "Die Collage konnte nicht übergeben werden. Öffnen Sie die Arbeit im «Verlauf» und versuchen Sie es erneut.",
    "Сетки": "Raster",
    "Свободно": "Frei",
    "Ретро": "Retro",
    "С текстом": "Mit Text",
    "Для соцсетей": "Für soziale Medien",
    "Мозаика": "Mosaik",
    "Кладка из ячеек разной высоты": "Mauerwerk aus Zellen unterschiedlicher Höhe",
    "Сетка 2×2": "Raster 2×2",
    "Четыре равные ячейки": "Vier gleiche Zellen",
    "Полароиды": "Polaroids",
    "Карточки в белых рамках, с наклоном": "Karten in weißen Rahmen, schräg",
    "Плёнка": "Film",
    "Кадры на плёнке и поле для подписи": "Bilder auf einem Filmstreifen und ein Feld für die Unterschrift",
    "Герой и два": "Hauptbild und zwei",
    "Крупное фото и два рядом": "Ein großes Foto und zwei daneben",
    "Сетка 3×3": "Raster 3×3",
    "Подборки и итоги года": "Auswahlen und Jahresrückblicke",
    "Герой и лента": "Hauptbild und Streifen",
    "Крупное фото и лента мелких": "Ein großes Foto und ein Streifen kleiner",
    "Журнал": "Magazin",
    "Заголовок, крупное фото и сноски": "Überschrift, großes Foto und Fußnoten",
    "Ленты во всю ширину, лучше в 9:16": "Streifen über die ganze Breite, am besten in 9:16",
    "Круги": "Kreise",
    "Фото в круглых окнах": "Fotos in runden Fenstern",
    "Сетка 2×3": "Raster 2×3",
    "Шесть равных ячеек": "Sechs gleiche Zellen",
    "До и после": "Vorher und nachher",
    "Два фото с подписями": "Zwei Fotos mit Beschriftung",
    "Мудборд": "Moodboard",
    "Скотч, наклон и заголовок": "Klebeband, Neigung und Überschrift",
    "Панорама": "Panorama",
    "Один кадр на несколько слайдов карусели": "Ein Bild über mehrere Karussell-Folien",
    "Печать": "Druck",
    "Широкий": "Breit",
    "Без отступов": "Ohne Abstände",
    "Тонкие": "Schmal",
    "Средние": "Mittel",
    "Широкие": "Breit",
    "Белый": "Weiß",
    "Чёрный": "Schwarz",
    "Бумага": "Papier",
    "Цвет из фото": "Farbe aus Foto",
    "Размытие из фото": "Unschärfe aus Foto",
    "Лето 2026": "Sommer 2026",
    "Наши выходные": "Unser Wochenende",
    "С днём рождения": "Alles Gute zum Geburtstag",
    "Дата": "Datum",
    "Январь": "Januar",
    "Февраль": "Februar",
    "Март": "März",
    "Апрель": "April",
    "Май": "Mai",
    "Июнь": "Juni",
    "Июль": "Juli",
    "Август": "August",
    "Сентябрь": "September",
    "Октябрь": "Oktober",
    "Ноябрь": "November",
    "Декабрь": "Dezember",
    "января": "Januar",
    "февраля": "Februar",
    "марта": "März",
    "апреля": "April",
    "мая": "Mai",
    "июня": "Juni",
    "июля": "Juli",
    "августа": "August",
    "сентября": "September",
    "октября": "Oktober",
    "ноября": "November",
    "декабря": "Dezember"
  },
  "fr": {
    "Создать коллаж · {0} C": "Créer le collage · {0} C",
    "от {0} до {1} фото": "de {0} à {1} photos",
    "Коллаж из фото": "Collage photo",
    "Перемешать": "Mélanger",
    "Загрузите свои фото: раскладка соберётся на них": "Importez vos photos : la mise en page se construira avec elles",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "Ajoutez encore {0} photos : la mise en page «{1}» en demande au moins {2}",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "La mise en page prend les {0} premières photos, les autres restent pour d’autres",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "Maintenez une photo et faites-la glisser sur une autre pour les échanger",
    "Перетащите фото на другое, чтобы поменять их местами": "Faites glisser une photo sur une autre pour les échanger",
    "Раскладка": "Mise en page",
    "Все раскладки": "Toutes les mises en page",
    "Размытие": "Flou",
    "Из фото": "Depuis une photo",
    "Отступы": "Marges",
    "Например: лето у моря": "Par exemple : l’été à la mer",
    "Наберём нашим шрифтом": "Nous le composons dans notre police",
    "Добавьте хотя бы {0} фото": "Ajoutez au moins {0} photos",
    "Для этой раскладки нужно {0} фото": "Cette mise en page demande {0} photos",
    "{0} длиннее {1} знаков": "{0} dépasse {1} caractères",
    "Раскладки": "Mises en page",
    "Искать среди {0} раскладок": "Rechercher parmi {0} mises en page",
    "Коллаж «{0}»": "Collage «{0}»",
    "Подтвердите права на фото": "Confirmez les droits sur les photos",
    "Создать коллаж": "Créer le collage",
    "Этот вариант пока недоступен": "Cette option n’est pas encore disponible",
    "Загружаем фото": "Envoi des photos",
    "за коллаж": "par collage",
    "Пример {0}": "Exemple {0}",
    "Загрузите от {0} до {1} фото": "Importez de {0} à {1} photos",
    "Порядок поменяете прямо в раскладке": "Vous changerez l’ordre directement dans la mise en page",
    "Бот уже прислал его в чат, в отдельную тему.": "Le bot l’a déjà envoyé dans le chat, dans un sujet à part.",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "Le bot a déjà envoyé {0} diapositives dans le chat, dans un sujet à part. Publiez-les en carrousel, dans l’ordre.",
    "{0} слайда, {1}": "{0} diapositives, {1}",
    "фон {0}": "fond {0}",
    "без отступов": "sans marges",
    "{0} отступы": "marges : {0}",
    "Фото загружены": "Photos importées",
    "Проверяем фото": "Vérification de la photo",
    "Фото проверены": "Photos vérifiées",
    "Находим лица и главное": "Repérage des visages et de l’essentiel",
    "Кадры выровнены": "Cadrages alignés",
    "Выравниваем цвет": "Harmonisation des couleurs",
    "Цвет выровнен": "Couleurs harmonisées",
    "Собираем коллаж": "Assemblage du collage",
    "Коллаж собран": "Collage assemblé",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "Vous pouvez quitter l’écran : le bot enverra le collage dans le chat.",
    "Коллаж готов": "Le collage est prêt",
    "коллаж не создан": "le collage n’a pas été créé",
    "Не получилось собрать коллаж": "Impossible d’assembler le collage",
    "коллаж": "collage",
    "Подпись не прошла проверку": "La légende n’a pas passé la vérification",
    "Изменить подпись": "Modifier la légende",
    "Фото не прошли проверку": "Les photos n’ont pas passé la vérification",
    "На фото то, что мы не публикуем.": "Les photos montrent ce que nous ne publions pas.",
    "Заменить фото": "Remplacer la photo",
    "Ещё раскладка": "Autre mise en page",
    "Рилс из этих фото": "Reels avec ces photos",
    "Права на свои фото": "Droits sur vos photos",
    "Подтверждаю право использовать загружаемые фото": "Je confirme avoir le droit d’utiliser les photos envoyées",
    "на коллаже": "sur le collage",
    "Тут откроется тема чата, куда бот прислал коллаж": "Ici s’ouvrira le sujet du chat où le bot a envoyé le collage",
    "Коллаж ещё загружается": "Le collage est encore en chargement",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "Impossible de transmettre le collage. Ouvrez le travail dans «Historique» et réessayez.",
    "Сетки": "Grilles",
    "Свободно": "Libre",
    "Ретро": "Rétro",
    "С текстом": "Avec texte",
    "Для соцсетей": "Pour les réseaux sociaux",
    "Мозаика": "Mosaïque",
    "Кладка из ячеек разной высоты": "Un appareillage de cases de hauteurs différentes",
    "Сетка 2×2": "Grille 2×2",
    "Четыре равные ячейки": "Quatre cases égales",
    "Полароиды": "Polaroïds",
    "Карточки в белых рамках, с наклоном": "Cartes à cadre blanc, inclinées",
    "Плёнка": "Pellicule",
    "Кадры на плёнке и поле для подписи": "Des vues sur pellicule et un espace pour la légende",
    "Герой и два": "Principale et deux",
    "Крупное фото и два рядом": "Une grande photo et deux à côté",
    "Сетка 3×3": "Grille 3×3",
    "Подборки и итоги года": "Sélections et bilans de l’année",
    "Герой и лента": "Principale et bandeau",
    "Крупное фото и лента мелких": "Une grande photo et un bandeau de petites",
    "Журнал": "Magazine",
    "Заголовок, крупное фото и сноски": "Un titre, une grande photo et des notes",
    "Ленты во всю ширину, лучше в 9:16": "Bandeaux sur toute la largeur, idéal en 9:16",
    "Круги": "Cercles",
    "Фото в круглых окнах": "Des photos dans des fenêtres rondes",
    "Сетка 2×3": "Grille 2×3",
    "Шесть равных ячеек": "Six cases égales",
    "До и после": "Avant et après",
    "Два фото с подписями": "Deux photos avec légendes",
    "Мудборд": "Moodboard",
    "Скотч, наклон и заголовок": "Ruban adhésif, inclinaison et titre",
    "Панорама": "Panorama",
    "Один кадр на несколько слайдов карусели": "Une seule image sur plusieurs diapositives du carrousel",
    "Печать": "Impression",
    "Широкий": "Large",
    "Без отступов": "Sans marges",
    "Тонкие": "Fines",
    "Средние": "Moyennes",
    "Широкие": "Larges",
    "Белый": "Blanc",
    "Чёрный": "Noir",
    "Бумага": "Papier",
    "Цвет из фото": "Couleur de la photo",
    "Размытие из фото": "Flou de la photo",
    "Лето 2026": "Été 2026",
    "Наши выходные": "Notre week-end",
    "С днём рождения": "Joyeux anniversaire",
    "Дата": "Date",
    "Январь": "Janvier",
    "Февраль": "Février",
    "Март": "Mars",
    "Апрель": "Avril",
    "Май": "Mai",
    "Июнь": "Juin",
    "Июль": "Juillet",
    "Август": "Août",
    "Сентябрь": "Septembre",
    "Октябрь": "Octobre",
    "Ноябрь": "Novembre",
    "Декабрь": "Décembre",
    "января": "janvier",
    "февраля": "février",
    "марта": "mars",
    "апреля": "avril",
    "мая": "mai",
    "июня": "juin",
    "июля": "juillet",
    "августа": "août",
    "сентября": "septembre",
    "октября": "octobre",
    "ноября": "novembre",
    "декабря": "décembre"
  },
  "pt": {
    "Создать коллаж · {0} C": "Criar colagem · {0} C",
    "от {0} до {1} фото": "de {0} a {1} fotos",
    "Коллаж из фото": "Colagem de fotos",
    "Перемешать": "Embaralhar",
    "Загрузите свои фото: раскладка соберётся на них": "Envie suas fotos: o layout será montado com elas",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "Adicione mais {0} fotos: o layout «{1}» precisa de pelo menos {2}",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "O layout usa as primeiras {0} fotos; as demais ficam para outros",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "Segure uma foto e arraste para outra para trocá-las",
    "Перетащите фото на другое, чтобы поменять их местами": "Arraste uma foto para outra para trocá-las",
    "Раскладка": "Layout",
    "Все раскладки": "Todos os layouts",
    "Размытие": "Desfoque",
    "Из фото": "A partir de foto",
    "Отступы": "Espaçamento",
    "Например: лето у моря": "Por exemplo: verão à beira-mar",
    "Наберём нашим шрифтом": "Escrevemos com a nossa fonte",
    "Добавьте хотя бы {0} фото": "Adicione pelo menos {0} fotos",
    "Для этой раскладки нужно {0} фото": "Este layout precisa de {0} fotos",
    "{0} длиннее {1} знаков": "{0} tem mais de {1} caracteres",
    "Раскладки": "Layouts",
    "Искать среди {0} раскладок": "Pesquisar entre {0} layouts",
    "Коллаж «{0}»": "Colagem «{0}»",
    "Подтвердите права на фото": "Confirme os direitos sobre as fotos",
    "Создать коллаж": "Criar colagem",
    "Этот вариант пока недоступен": "Esta opção ainda não está disponível",
    "Загружаем фото": "Enviando fotos",
    "за коллаж": "por colagem",
    "Пример {0}": "Exemplo {0}",
    "Загрузите от {0} до {1} фото": "Envie de {0} a {1} fotos",
    "Порядок поменяете прямо в раскладке": "Você muda a ordem direto no layout",
    "Бот уже прислал его в чат, в отдельную тему.": "O bot já o enviou para o chat, num tópico separado.",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "O bot já enviou {0} slides para o chat, em um tópico separado. Publique-os como carrossel, na ordem.",
    "{0} слайда, {1}": "{0} slides, {1}",
    "фон {0}": "fundo {0}",
    "без отступов": "sem espaçamento",
    "{0} отступы": "espaçamento: {0}",
    "Фото загружены": "Fotos enviadas",
    "Проверяем фото": "Verificando a foto",
    "Фото проверены": "Fotos verificadas",
    "Находим лица и главное": "Encontrando rostos e o principal",
    "Кадры выровнены": "Enquadramentos ajustados",
    "Выравниваем цвет": "Equilibrando a cor",
    "Цвет выровнен": "Cor equilibrada",
    "Собираем коллаж": "Montando a colagem",
    "Коллаж собран": "Colagem montada",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "Você pode sair da tela: o bot enviará a colagem para o chat.",
    "Коллаж готов": "A colagem está pronta",
    "коллаж не создан": "a colagem não foi criada",
    "Не получилось собрать коллаж": "Não foi possível montar a colagem",
    "коллаж": "colagem",
    "Подпись не прошла проверку": "A legenda não passou na verificação",
    "Изменить подпись": "Alterar a legenda",
    "Фото не прошли проверку": "As fotos não passaram na verificação",
    "На фото то, что мы не публикуем.": "As fotos mostram algo que não publicamos.",
    "Заменить фото": "Trocar a foto",
    "Ещё раскладка": "Outro layout",
    "Рилс из этих фото": "Reels com estas fotos",
    "Права на свои фото": "Direitos sobre suas fotos",
    "Подтверждаю право использовать загружаемые фото": "Confirmo o direito de usar as fotos enviadas",
    "на коллаже": "na colagem",
    "Тут откроется тема чата, куда бот прислал коллаж": "Aqui vai abrir o tópico do chat onde o bot enviou a colagem",
    "Коллаж ещё загружается": "A colagem ainda está carregando",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "Não foi possível passar a colagem. Abra o trabalho em «Histórico» e tente novamente.",
    "Сетки": "Grades",
    "Свободно": "Livre",
    "Ретро": "Retro",
    "С текстом": "Com texto",
    "Для соцсетей": "Para redes sociais",
    "Мозаика": "Mosaico",
    "Кладка из ячеек разной высоты": "Alvenaria de células de alturas diferentes",
    "Сетка 2×2": "Grade 2×2",
    "Четыре равные ячейки": "Quatro células iguais",
    "Полароиды": "Polaroides",
    "Карточки в белых рамках, с наклоном": "Cartões com moldura branca, inclinados",
    "Плёнка": "Filme",
    "Кадры на плёнке и поле для подписи": "Quadros em filme e um campo para a legenda",
    "Герой и два": "Destaque e dois",
    "Крупное фото и два рядом": "Uma foto grande e duas ao lado",
    "Сетка 3×3": "Grade 3×3",
    "Подборки и итоги года": "Seleções e retrospectivas do ano",
    "Герой и лента": "Destaque e faixa",
    "Крупное фото и лента мелких": "Uma foto grande e uma faixa de pequenas",
    "Журнал": "Revista",
    "Заголовок, крупное фото и сноски": "Título, foto grande e notas",
    "Ленты во всю ширину, лучше в 9:16": "Faixas em toda a largura, melhor em 9:16",
    "Круги": "Círculos",
    "Фото в круглых окнах": "Fotos em janelas redondas",
    "Сетка 2×3": "Grade 2×3",
    "Шесть равных ячеек": "Seis células iguais",
    "До и после": "Antes e depois",
    "Два фото с подписями": "Duas fotos com legendas",
    "Мудборд": "Moodboard",
    "Скотч, наклон и заголовок": "Fita adesiva, inclinação e título",
    "Панорама": "Panorama",
    "Один кадр на несколько слайдов карусели": "Uma imagem em vários slides do carrossel",
    "Печать": "Impressão",
    "Широкий": "Largo",
    "Без отступов": "Sem espaçamento",
    "Тонкие": "Finos",
    "Средние": "Médios",
    "Широкие": "Largos",
    "Белый": "Branco",
    "Чёрный": "Preto",
    "Бумага": "Papel",
    "Цвет из фото": "Cor da foto",
    "Размытие из фото": "Desfoque da foto",
    "Лето 2026": "Verão 2026",
    "Наши выходные": "Nosso fim de semana",
    "С днём рождения": "Feliz aniversário",
    "Дата": "Data",
    "Январь": "Janeiro",
    "Февраль": "Fevereiro",
    "Март": "Março",
    "Апрель": "Abril",
    "Май": "Maio",
    "Июнь": "Junho",
    "Июль": "Julho",
    "Август": "Agosto",
    "Сентябрь": "Setembro",
    "Октябрь": "Outubro",
    "Ноябрь": "Novembro",
    "Декабрь": "Dezembro",
    "января": "de janeiro de",
    "февраля": "de fevereiro de",
    "марта": "de março de",
    "апреля": "de abril de",
    "мая": "de maio de",
    "июня": "de junho de",
    "июля": "de julho de",
    "августа": "de agosto de",
    "сентября": "de setembro de",
    "октября": "de outubro de",
    "ноября": "de novembro de",
    "декабря": "de dezembro de"
  },
  "tr": {
    "Создать коллаж · {0} C": "Kolaj oluştur · {0} C",
    "от {0} до {1} фото": "{0}–{1} fotoğraf",
    "Коллаж из фото": "Fotoğraf kolajı",
    "Перемешать": "Karıştır",
    "Загрузите свои фото: раскладка соберётся на них": "Fotoğraflarınızı yükleyin: düzen onlarla oluşturulacak",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "{0} fotoğraf daha ekleyin: «{1}» düzeni en az {2} istiyor",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "Düzene ilk {0} fotoğraf girer, kalanlar diğerleri için kalır",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "Yer değiştirmek için bir fotoğrafı basılı tutup diğerinin üzerine sürükleyin",
    "Перетащите фото на другое, чтобы поменять их местами": "Yer değiştirmek için bir fotoğrafı diğerinin üzerine sürükleyin",
    "Раскладка": "Düzen",
    "Все раскладки": "Tüm düzenler",
    "Размытие": "Bulanık",
    "Из фото": "Fotoğraftan",
    "Отступы": "Boşluklar",
    "Например: лето у моря": "Örneğin: deniz kenarında yaz",
    "Наберём нашим шрифтом": "Kendi yazı tipimizle dizeriz",
    "Добавьте хотя бы {0} фото": "En az {0} fotoğraf ekleyin",
    "Для этой раскладки нужно {0} фото": "Bu düzen için {0} fotoğraf gerekli",
    "{0} длиннее {1} знаков": "{0}, {1} karakterden uzun",
    "Раскладки": "Düzenler",
    "Искать среди {0} раскладок": "{0} düzen arasında ara",
    "Коллаж «{0}»": "«{0}» kolajı",
    "Подтвердите права на фото": "Fotoğraf haklarını onaylayın",
    "Создать коллаж": "Kolaj oluştur",
    "Этот вариант пока недоступен": "Bu seçenek henüz kullanılamıyor",
    "Загружаем фото": "Fotoğraflar yükleniyor",
    "за коллаж": "kolaj başına",
    "Пример {0}": "Örnek {0}",
    "Загрузите от {0} до {1} фото": "{0} ile {1} arası fotoğraf yükleyin",
    "Порядок поменяете прямо в раскладке": "Sırayı doğrudan düzende değiştirirsiniz",
    "Бот уже прислал его в чат, в отдельную тему.": "Bot onu sohbete, ayrı bir konuya zaten gönderdi.",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "Bot {0} slaytı zaten sohbete, ayrı bir konuya gönderdi. Onları sırayla karusel olarak yayınlayın.",
    "{0} слайда, {1}": "{0} slayt, {1}",
    "фон {0}": "{0} arka plan",
    "без отступов": "boşluksuz",
    "{0} отступы": "{0} boşluklar",
    "Фото загружены": "Fotoğraflar yüklendi",
    "Проверяем фото": "Fotoğraf kontrol ediliyor",
    "Фото проверены": "Fotoğraflar kontrol edildi",
    "Находим лица и главное": "Yüzleri ve ana öğeyi buluyoruz",
    "Кадры выровнены": "Kareler hizalandı",
    "Выравниваем цвет": "Renk eşitleniyor",
    "Цвет выровнен": "Renk eşitlendi",
    "Собираем коллаж": "Kolaj hazırlanıyor",
    "Коллаж собран": "Kolaj hazır",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "Ekrandan çıkabilirsiniz: bot kolajı sohbete gönderecek.",
    "Коллаж готов": "Kolaj hazır",
    "коллаж не создан": "kolaj oluşturulmadı",
    "Не получилось собрать коллаж": "Kolaj hazırlanamadı",
    "коллаж": "kolaj",
    "Подпись не прошла проверку": "Altyazı kontrolden geçmedi",
    "Изменить подпись": "Altyazıyı değiştir",
    "Фото не прошли проверку": "Fotoğraflar kontrolden geçmedi",
    "На фото то, что мы не публикуем.": "Fotoğraflarda yayınlamadığımız bir şey var.",
    "Заменить фото": "Fotoğrafı değiştir",
    "Ещё раскладка": "Başka düzen",
    "Рилс из этих фото": "Bu fotoğraflardan Reels",
    "Права на свои фото": "Fotoğraflarınızın hakları",
    "Подтверждаю право использовать загружаемые фото": "Yüklenen fotoğrafları kullanma hakkını onaylıyorum",
    "на коллаже": "kolajda",
    "Тут откроется тема чата, куда бот прислал коллаж": "Burada botun kolajı gönderdiği sohbet konusu açılacak",
    "Коллаж ещё загружается": "Kolaj hâlâ yükleniyor",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "Kolaj aktarılamadı. Çalışmayı «Geçmiş» içinde açıp tekrar deneyin.",
    "Сетки": "Izgaralar",
    "Свободно": "Serbest",
    "Ретро": "Retro",
    "С текстом": "Metinli",
    "Для соцсетей": "Sosyal medya için",
    "Мозаика": "Mozaik",
    "Кладка из ячеек разной высоты": "Farklı yükseklikte hücrelerden örgü",
    "Сетка 2×2": "Izgara 2×2",
    "Четыре равные ячейки": "Dört eşit hücre",
    "Полароиды": "Polaroidler",
    "Карточки в белых рамках, с наклоном": "Beyaz çerçeveli, eğik kartlar",
    "Плёнка": "Film",
    "Кадры на плёнке и поле для подписи": "Film şeridinde kareler ve altyazı alanı",
    "Герой и два": "Ana kare ve iki",
    "Крупное фото и два рядом": "Büyük bir fotoğraf ve yanında iki",
    "Сетка 3×3": "Izgara 3×3",
    "Подборки и итоги года": "Seçkiler ve yıl özeti",
    "Герой и лента": "Ana kare ve şerit",
    "Крупное фото и лента мелких": "Büyük bir fotoğraf ve küçüklerden şerit",
    "Журнал": "Dergi",
    "Заголовок, крупное фото и сноски": "Başlık, büyük fotoğraf ve dipnotlar",
    "Ленты во всю ширину, лучше в 9:16": "Tam genişlikte şeritler, en iyisi 9:16",
    "Круги": "Daireler",
    "Фото в круглых окнах": "Yuvarlak pencerelerde fotoğraflar",
    "Сетка 2×3": "Izgara 2×3",
    "Шесть равных ячеек": "Altı eşit hücre",
    "До и после": "Önce ve sonra",
    "Два фото с подписями": "Etiketli iki fotoğraf",
    "Мудборд": "Moodboard",
    "Скотч, наклон и заголовок": "Bant, eğim ve başlık",
    "Панорама": "Panorama",
    "Один кадр на несколько слайдов карусели": "Birkaç karusel slaytına yayılan tek kare",
    "Печать": "Baskı",
    "Широкий": "Geniş",
    "Без отступов": "Boşluksuz",
    "Тонкие": "İnce",
    "Средние": "Orta",
    "Широкие": "Geniş",
    "Белый": "Beyaz",
    "Чёрный": "Siyah",
    "Бумага": "Kâğıt",
    "Цвет из фото": "Fotoğraftan renk",
    "Размытие из фото": "Fotoğraftan bulanıklık",
    "Лето 2026": "Yaz 2026",
    "Наши выходные": "Hafta sonumuz",
    "С днём рождения": "Doğum günün kutlu olsun",
    "Дата": "Tarih",
    "Январь": "Ocak",
    "Февраль": "Şubat",
    "Март": "Mart",
    "Апрель": "Nisan",
    "Май": "Mayıs",
    "Июнь": "Haziran",
    "Июль": "Temmuz",
    "Август": "Ağustos",
    "Сентябрь": "Eylül",
    "Октябрь": "Ekim",
    "Ноябрь": "Kasım",
    "Декабрь": "Aralık",
    "января": "Ocak",
    "февраля": "Şubat",
    "марта": "Mart",
    "апреля": "Nisan",
    "мая": "Mayıs",
    "июня": "Haziran",
    "июля": "Temmuz",
    "августа": "Ağustos",
    "сентября": "Eylül",
    "октября": "Ekim",
    "ноября": "Kasım",
    "декабря": "Aralık"
  },
  "kk": {
    "Создать коллаж · {0} C": "Коллаж жасау · {0} C",
    "от {0} до {1} фото": "{0}–{1} фото",
    "Коллаж из фото": "Фото коллажы",
    "Перемешать": "Араластыру",
    "Загрузите свои фото: раскладка соберётся на них": "Фотоларыңызды жүктеңіз: орналасым солардан құрылады",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "Тағы {0} фото қосыңыз: «{1}» орналасымына кемінде {2} керек",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "Орналасымға алғашқы {0} фото кіреді, қалғаны басқаларға қалады",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "Орнын ауыстыру үшін фотоны басып тұрып, басқасының үстіне апарыңыз",
    "Перетащите фото на другое, чтобы поменять их местами": "Орнын ауыстыру үшін фотоны басқасының үстіне сүйреңіз",
    "Раскладка": "Орналасым",
    "Все раскладки": "Барлық орналасым",
    "Размытие": "Бұлыңғыр",
    "Из фото": "Фотодан",
    "Отступы": "Аралықтар",
    "Например: лето у моря": "Мысалы: теңіз жағасындағы жаз",
    "Наберём нашим шрифтом": "Өз қаріпімізбен тереміз",
    "Добавьте хотя бы {0} фото": "Кемінде {0} фото қосыңыз",
    "Для этой раскладки нужно {0} фото": "Бұл орналасымға {0} фото керек",
    "{0} длиннее {1} знаков": "{0} {1} таңбадан ұзын",
    "Раскладки": "Орналасымдар",
    "Искать среди {0} раскладок": "{0} орналасымнан іздеу",
    "Коллаж «{0}»": "«{0}» коллажы",
    "Подтвердите права на фото": "Фотоға құқықты растаңыз",
    "Создать коллаж": "Коллаж жасау",
    "Этот вариант пока недоступен": "Бұл нұсқа әзірге қолжетімсіз",
    "Загружаем фото": "Фото жүктеліп жатыр",
    "за коллаж": "бір коллаж үшін",
    "Пример {0}": "{0}-мысал",
    "Загрузите от {0} до {1} фото": "{0}–{1} фото жүктеңіз",
    "Порядок поменяете прямо в раскладке": "Ретін тікелей орналасымда өзгертесіз",
    "Бот уже прислал его в чат, в отдельную тему.": "Бот оны чатқа, жеке тақырыпқа жіберіп қойды.",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "Бот {0} слайдты чатқа, жеке тақырыпқа жіберіп қойды. Оларды карусель етіп ретімен жариялаңыз.",
    "{0} слайда, {1}": "{0} слайд, {1}",
    "фон {0}": "{0} фон",
    "без отступов": "аралықсыз",
    "{0} отступы": "{0} аралықтар",
    "Фото загружены": "Фотолар жүктелді",
    "Проверяем фото": "Фото тексерілуде",
    "Фото проверены": "Фотосуреттер тексерілді",
    "Находим лица и главное": "Беттер мен бастысын табамыз",
    "Кадры выровнены": "Кадрлар түзетілді",
    "Выравниваем цвет": "Түсті теңестіреміз",
    "Цвет выровнен": "Түс теңестірілді",
    "Собираем коллаж": "Коллажды құрастырамыз",
    "Коллаж собран": "Коллаж құрастырылды",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "Экраннан шығуға болады: бот коллажды чатқа жібереді.",
    "Коллаж готов": "Коллаж дайын",
    "коллаж не создан": "коллаж жасалмады",
    "Не получилось собрать коллаж": "Коллажды құрастыру мүмкін болмады",
    "коллаж": "коллаж",
    "Подпись не прошла проверку": "Жазба тексеруден өтпеді",
    "Изменить подпись": "Жазбаны өзгерту",
    "Фото не прошли проверку": "Фотолар тексерістен өтпеді",
    "На фото то, что мы не публикуем.": "Фотода біз жарияламайтын нәрсе бар.",
    "Заменить фото": "Фотоны ауыстыру",
    "Ещё раскладка": "Басқа орналасым",
    "Рилс из этих фото": "Осы фотолардан рилс",
    "Права на свои фото": "Өз фотоларыңызға құқық",
    "Подтверждаю право использовать загружаемые фото": "Жүктелетін фотоларды пайдалану құқығын растаймын",
    "на коллаже": "коллажда",
    "Тут откроется тема чата, куда бот прислал коллаж": "Мұнда бот коллажды жіберген чат тақырыбы ашылады",
    "Коллаж ещё загружается": "Коллаж әлі жүктеліп жатыр",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "Коллажды беру мүмкін болмады. Жұмысты «Тарихта» ашып, қайта көріңіз.",
    "Сетки": "Торлар",
    "Свободно": "Еркін",
    "Ретро": "Ретро",
    "С текстом": "Мәтінмен",
    "Для соцсетей": "Әлеуметтік желілер үшін",
    "Мозаика": "Мозаика",
    "Кладка из ячеек разной высоты": "Әр биіктіктегі ұяшықтардан қалау",
    "Сетка 2×2": "Тор 2×2",
    "Четыре равные ячейки": "Төрт тең ұяшық",
    "Полароиды": "Полароидтар",
    "Карточки в белых рамках, с наклоном": "Ақ жиекті, көлбеу карточкалар",
    "Плёнка": "Пленка",
    "Кадры на плёнке и поле для подписи": "Пленкадағы кадрлар және жазба өрісі",
    "Герой и два": "Басты және екеу",
    "Крупное фото и два рядом": "Үлкен фото және жанында екеу",
    "Сетка 3×3": "Тор 3×3",
    "Подборки и итоги года": "Іріктемелер мен жыл қорытындысы",
    "Герой и лента": "Басты және таспа",
    "Крупное фото и лента мелких": "Үлкен фото және кішілердің таспасы",
    "Журнал": "Журнал",
    "Заголовок, крупное фото и сноски": "Тақырып, үлкен фото және ескертпелер",
    "Ленты во всю ширину, лучше в 9:16": "Толық ендік таспалар, 9:16 жақсырақ",
    "Круги": "Шеңберлер",
    "Фото в круглых окнах": "Дөңгелек терезелердегі фото",
    "Сетка 2×3": "Тор 2×3",
    "Шесть равных ячеек": "Алты тең ұяшық",
    "До и после": "Дейін және кейін",
    "Два фото с подписями": "Жазбалары бар екі фото",
    "Мудборд": "Мудборд",
    "Скотч, наклон и заголовок": "Скотч, көлбеу және тақырып",
    "Панорама": "Панорама",
    "Один кадр на несколько слайдов карусели": "Каруселдің бірнеше слайдына бір кадр",
    "Печать": "Басып шығару",
    "Широкий": "Кең",
    "Без отступов": "Аралықсыз",
    "Тонкие": "Жіңішке",
    "Средние": "Орташа",
    "Широкие": "Кең",
    "Белый": "Ақ",
    "Чёрный": "Қара",
    "Бумага": "Қағаз",
    "Цвет из фото": "Фотодан түс",
    "Размытие из фото": "Фотодан бұлыңғыр",
    "Лето 2026": "Жаз 2026",
    "Наши выходные": "Біздің демалыс",
    "С днём рождения": "Туған күніңмен",
    "Дата": "Күні",
    "Январь": "Қаңтар",
    "Февраль": "Ақпан",
    "Март": "Наурыз",
    "Апрель": "Сәуір",
    "Май": "Мамыр",
    "Июнь": "Маусым",
    "Июль": "Шілде",
    "Август": "Тамыз",
    "Сентябрь": "Қыркүйек",
    "Октябрь": "Қазан",
    "Ноябрь": "Қараша",
    "Декабрь": "Желтоқсан",
    "января": "қаңтар",
    "февраля": "ақпан",
    "марта": "наурыз",
    "апреля": "сәуір",
    "мая": "мамыр",
    "июня": "маусым",
    "июля": "шілде",
    "августа": "тамыз",
    "сентября": "қыркүйек",
    "октября": "қазан",
    "ноября": "қараша",
    "декабря": "желтоқсан"
  },
  "uk": {
    "Создать коллаж · {0} C": "Створити колаж · {0} C",
    "от {0} до {1} фото": "від {0} до {1} фото",
    "Коллаж из фото": "Колаж із фото",
    "Перемешать": "Перемішати",
    "Загрузите свои фото: раскладка соберётся на них": "Завантажте свої фото: розкладка збереться з них",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "Додайте ще {0} фото: розкладці «{1}» потрібно від {2}",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "До розкладки ввійдуть перші {0} фото, решта залишаться для інших",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "Утримуйте фото й ведіть на інше, щоб поміняти їх місцями",
    "Перетащите фото на другое, чтобы поменять их местами": "Перетягніть фото на інше, щоб поміняти їх місцями",
    "Раскладка": "Розкладка",
    "Все раскладки": "Усі розкладки",
    "Размытие": "Розмиття",
    "Из фото": "З фото",
    "Отступы": "Відступи",
    "Например: лето у моря": "Наприклад: літо біля моря",
    "Наберём нашим шрифтом": "Наберемо нашим шрифтом",
    "Добавьте хотя бы {0} фото": "Додайте щонайменше {0} фото",
    "Для этой раскладки нужно {0} фото": "Для цієї розкладки потрібно {0} фото",
    "{0} длиннее {1} знаков": "{0} довший за {1} знаків",
    "Раскладки": "Розкладки",
    "Искать среди {0} раскладок": "Шукати серед {0} розкладок",
    "Коллаж «{0}»": "Колаж «{0}»",
    "Подтвердите права на фото": "Підтвердьте права на фото",
    "Создать коллаж": "Створити колаж",
    "Этот вариант пока недоступен": "Цей варіант поки недоступний",
    "Загружаем фото": "Завантажуємо фото",
    "за коллаж": "за колаж",
    "Пример {0}": "Приклад {0}",
    "Загрузите от {0} до {1} фото": "Завантажте від {0} до {1} фото",
    "Порядок поменяете прямо в раскладке": "Порядок зміните просто в розкладці",
    "Бот уже прислал его в чат, в отдельную тему.": "Бот уже надіслав його в чат, в окрему тему.",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "Бот уже надіслав {0} слайди в чат, в окрему тему. Публікуйте їх каруселлю по порядку.",
    "{0} слайда, {1}": "{0} слайди, {1}",
    "фон {0}": "тло {0}",
    "без отступов": "без відступів",
    "{0} отступы": "{0} відступи",
    "Фото загружены": "Фото завантажено",
    "Проверяем фото": "Перевіряємо фото",
    "Фото проверены": "Фото перевірено",
    "Находим лица и главное": "Знаходимо обличчя й головне",
    "Кадры выровнены": "Кадри вирівняно",
    "Выравниваем цвет": "Вирівнюємо колір",
    "Цвет выровнен": "Колір вирівняно",
    "Собираем коллаж": "Збираємо колаж",
    "Коллаж собран": "Колаж зібрано",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "Можна піти з екрана: бот надішле колаж у чат.",
    "Коллаж готов": "Колаж готовий",
    "коллаж не создан": "колаж не створено",
    "Не получилось собрать коллаж": "Не вдалося зібрати колаж",
    "коллаж": "колаж",
    "Подпись не прошла проверку": "Підпис не пройшов перевірку",
    "Изменить подпись": "Змінити підпис",
    "Фото не прошли проверку": "Фото не пройшли перевірку",
    "На фото то, что мы не публикуем.": "На фото те, що ми не публікуємо.",
    "Заменить фото": "Замінити фото",
    "Ещё раскладка": "Ще розкладка",
    "Рилс из этих фото": "Рілс із цих фото",
    "Права на свои фото": "Права на свої фото",
    "Подтверждаю право использовать загружаемые фото": "Підтверджую право використовувати завантажені фото",
    "на коллаже": "на колажі",
    "Тут откроется тема чата, куда бот прислал коллаж": "Тут відкриється тема чату, куди бот надіслав колаж",
    "Коллаж ещё загружается": "Колаж ще завантажується",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "Не вдалося передати колаж. Відкрийте роботу в «Історії» і спробуйте знову.",
    "Сетки": "Сітки",
    "Свободно": "Вільно",
    "Ретро": "Ретро",
    "С текстом": "З текстом",
    "Для соцсетей": "Для соцмереж",
    "Мозаика": "Мозаїка",
    "Кладка из ячеек разной высоты": "Кладка з комірок різної висоти",
    "Сетка 2×2": "Сітка 2×2",
    "Четыре равные ячейки": "Чотири рівні комірки",
    "Полароиды": "Полароїди",
    "Карточки в белых рамках, с наклоном": "Картки в білих рамках, з нахилом",
    "Плёнка": "Плівка",
    "Кадры на плёнке и поле для подписи": "Кадри на плівці й поле для підпису",
    "Герой и два": "Герой і два",
    "Крупное фото и два рядом": "Велике фото й два поруч",
    "Сетка 3×3": "Сітка 3×3",
    "Подборки и итоги года": "Добірки й підсумки року",
    "Герой и лента": "Герой і стрічка",
    "Крупное фото и лента мелких": "Велике фото й стрічка дрібних",
    "Журнал": "Журнал",
    "Заголовок, крупное фото и сноски": "Заголовок, велике фото й виноски",
    "Ленты во всю ширину, лучше в 9:16": "Стрічки на всю ширину, краще у 9:16",
    "Круги": "Кола",
    "Фото в круглых окнах": "Фото в круглих вікнах",
    "Сетка 2×3": "Сітка 2×3",
    "Шесть равных ячеек": "Шість рівних комірок",
    "До и после": "До і після",
    "Два фото с подписями": "Два фото з підписами",
    "Мудборд": "Мудборд",
    "Скотч, наклон и заголовок": "Скотч, нахил і заголовок",
    "Панорама": "Панорама",
    "Один кадр на несколько слайдов карусели": "Один кадр на кілька слайдів каруселі",
    "Печать": "Друк",
    "Широкий": "Широкий",
    "Без отступов": "Без відступів",
    "Тонкие": "Тонкі",
    "Средние": "Середні",
    "Широкие": "Широкі",
    "Белый": "Білий",
    "Чёрный": "Чорний",
    "Бумага": "Папір",
    "Цвет из фото": "Колір із фото",
    "Размытие из фото": "Розмиття з фото",
    "Лето 2026": "Літо 2026",
    "Наши выходные": "Наші вихідні",
    "С днём рождения": "З днем народження",
    "Дата": "Дата",
    "Январь": "Січень",
    "Февраль": "Лютий",
    "Март": "Березень",
    "Апрель": "Квітень",
    "Май": "Травень",
    "Июнь": "Червень",
    "Июль": "Липень",
    "Август": "Серпень",
    "Сентябрь": "Вересень",
    "Октябрь": "Жовтень",
    "Ноябрь": "Листопад",
    "Декабрь": "Грудень",
    "января": "січня",
    "февраля": "лютого",
    "марта": "березня",
    "апреля": "квітня",
    "мая": "травня",
    "июня": "червня",
    "июля": "липня",
    "августа": "серпня",
    "сентября": "вересня",
    "октября": "жовтня",
    "ноября": "листопада",
    "декабря": "грудня"
  },
  "zh": {
    "Создать коллаж · {0} C": "创建拼贴 · {0} C",
    "от {0} до {1} фото": "{0} 到 {1} 张照片",
    "Коллаж из фото": "照片拼贴",
    "Перемешать": "随机打乱",
    "Загрузите свои фото: раскладка соберётся на них": "上传你的照片：版式将用它们生成",
    "Добавьте ещё {0} фото: раскладке «{1}» нужно от {2}": "再添加 {0} 张照片：「{1}」版式至少需要 {2} 张",
    "В раскладку войдут первые {0} фото, остальные останутся для других": "版式使用前 {0} 张照片，其余留给其他版式",
    "Удерживайте фото и ведите на другое, чтобы поменять их местами": "按住照片拖到另一张上即可交换位置",
    "Перетащите фото на другое, чтобы поменять их местами": "把照片拖到另一张上即可交换位置",
    "Раскладка": "布局",
    "Все раскладки": "全部版式",
    "Размытие": "模糊",
    "Из фото": "取自照片",
    "Отступы": "间距",
    "Например: лето у моря": "例如：海边的夏天",
    "Наберём нашим шрифтом": "用我们的字体排版",
    "Добавьте хотя бы {0} фото": "请至少添加 {0} 张照片",
    "Для этой раскладки нужно {0} фото": "此版式需要 {0} 张照片",
    "{0} длиннее {1} знаков": "{0}超过 {1} 个字符",
    "Раскладки": "版式",
    "Искать среди {0} раскладок": "在 {0} 个版式中搜索",
    "Коллаж «{0}»": "拼贴「{0}」",
    "Подтвердите права на фото": "请确认照片使用权",
    "Создать коллаж": "创建拼贴",
    "Этот вариант пока недоступен": "此选项暂不可用",
    "Загружаем фото": "正在上传照片",
    "за коллаж": "每张拼贴",
    "Пример {0}": "示例 {0}",
    "Загрузите от {0} до {1} фото": "上传 {0} 到 {1} 张照片",
    "Порядок поменяете прямо в раскладке": "可以直接在版式中调整顺序",
    "Бот уже прислал его в чат, в отдельную тему.": "机器人已把它发到聊天的单独话题中。",
    "Бот уже прислал {0} слайда в чат, в отдельную тему. Публикуйте их каруселью по порядку.": "机器人已把 {0} 张幻灯片发到聊天的单独话题中。请按顺序以轮播形式发布。",
    "{0} слайда, {1}": "{0} 张幻灯片，{1}",
    "фон {0}": "{0}背景",
    "без отступов": "无间距",
    "{0} отступы": "{0}间距",
    "Фото загружены": "照片已上传",
    "Проверяем фото": "正在检查照片",
    "Фото проверены": "照片已检查",
    "Находим лица и главное": "正在识别人脸和主体",
    "Кадры выровнены": "画面已对齐",
    "Выравниваем цвет": "正在统一色调",
    "Цвет выровнен": "色调已统一",
    "Собираем коллаж": "正在生成拼贴",
    "Коллаж собран": "拼贴已生成",
    "Можно уйти с экрана: бот пришлёт коллаж в чат.": "可以离开此页面：机器人会把拼贴发到聊天中。",
    "Коллаж готов": "拼贴已完成",
    "коллаж не создан": "拼贴未创建",
    "Не получилось собрать коллаж": "拼贴生成失败",
    "коллаж": "拼贴",
    "Подпись не прошла проверку": "文字未通过审核",
    "Изменить подпись": "修改文字",
    "Фото не прошли проверку": "照片未通过审核",
    "На фото то, что мы не публикуем.": "照片包含我们不发布的内容。",
    "Заменить фото": "替换照片",
    "Ещё раскладка": "换个版式",
    "Рилс из этих фото": "用这些照片做 Reels",
    "Права на свои фото": "照片使用权",
    "Подтверждаю право использовать загружаемые фото": "我确认有权使用上传的照片",
    "на коллаже": "拼贴上",
    "Тут откроется тема чата, куда бот прислал коллаж": "这里会打开机器人发送拼贴的聊天话题",
    "Коллаж ещё загружается": "拼贴仍在加载",
    "Не удалось передать коллаж. Откройте работу в «Истории» и попробуйте снова.": "拼贴传送失败。请在「历史」中打开作品并重试。",
    "Сетки": "网格",
    "Свободно": "自由",
    "Ретро": "复古",
    "С текстом": "带文字",
    "Для соцсетей": "社交媒体",
    "Мозаика": "马赛克",
    "Кладка из ячеек разной высоты": "高低不一的瀑布流格子",
    "Сетка 2×2": "2×2 网格",
    "Четыре равные ячейки": "四个等大格子",
    "Полароиды": "拍立得",
    "Карточки в белых рамках, с наклоном": "白框卡片，带倾斜",
    "Плёнка": "胶片",
    "Кадры на плёнке и поле для подписи": "胶片画面和文字栏",
    "Герой и два": "主图加两张",
    "Крупное фото и два рядом": "一张大图，旁边两张",
    "Сетка 3×3": "3×3 网格",
    "Подборки и итоги года": "精选和年度回顾",
    "Герой и лента": "主图加胶条",
    "Крупное фото и лента мелких": "一张大图和一排小图",
    "Журнал": "杂志",
    "Заголовок, крупное фото и сноски": "标题、大图和注释",
    "Ленты во всю ширину, лучше в 9:16": "全宽横条，最好用 9:16",
    "Круги": "圆形",
    "Фото в круглых окнах": "圆形窗口中的照片",
    "Сетка 2×3": "2×3 网格",
    "Шесть равных ячеек": "六个等大格子",
    "До и после": "前后对比",
    "Два фото с подписями": "两张带标注的照片",
    "Мудборд": "情绪板",
    "Скотч, наклон и заголовок": "胶带、倾斜和标题",
    "Панорама": "全景",
    "Один кадр на несколько слайдов карусели": "一张照片横跨多张轮播幻灯片",
    "Печать": "打印",
    "Широкий": "宽屏",
    "Без отступов": "无间距",
    "Тонкие": "细",
    "Средние": "中",
    "Широкие": "宽",
    "Белый": "白色",
    "Чёрный": "黑色",
    "Бумага": "纸张",
    "Цвет из фото": "取自照片的颜色",
    "Размытие из фото": "取自照片的模糊",
    "Лето 2026": "2026 年夏天",
    "Наши выходные": "我们的周末",
    "С днём рождения": "生日快乐",
    "Дата": "日期",
    "Январь": "1月",
    "Февраль": "2月",
    "Март": "3月",
    "Апрель": "4月",
    "Май": "5月",
    "Июнь": "6月",
    "Июль": "7月",
    "Август": "8月",
    "Сентябрь": "9月",
    "Октябрь": "10月",
    "Ноябрь": "11月",
    "Декабрь": "12月",
    "января": "1月",
    "февраля": "2月",
    "марта": "3月",
    "апреля": "4月",
    "мая": "5月",
    "июня": "6月",
    "июля": "7月",
    "августа": "8月",
    "сентября": "9月",
    "октября": "10月",
    "ноября": "11月",
    "декабря": "12月"
  }
}
